<ng-container *transloco="let t">
  <ld-base-modal [title]="t('goPaperlessTitle')" size="large" (closeModal)="close.emit()">
    <div modal-content>
      <div id="paperless-prompt-modal-body" class="flex flex-col md:flex-row gap-6">
        <div id="paperless-prompt-image-container" class="hidden md:block md:w-1/2">
          <img
            id="paperless-prompt-image"
            ngSrc="assets/images/paperless.jpg"
            alt=""
            width="384"
            height="480"
            class="w-full h-full object-cover rounded-lg"
            priority
          />
        </div>

        <div class="flex-1 flex flex-col justify-center">
          <p id="paperless-prompt-modal-description" class="text-ld-neutral-600 text-center md:text-left mb-4">
            {{ t('goPaperlessDescription') }}
          </p>

          <ul id="paperless-prompt-benefits-list" class="list-disc text-ld-neutral-600 mb-6 space-y-1 pl-5">
            <li id="paperless-benefit-1">{{ t('goPaperlessBenefitsQuickAccess') }}</li>
            <li id="paperless-benefit-2">{{ t('goPaperlessBenefitsConvenient') }}</li>
            <li id="paperless-benefit-3">{{ t('goPaperlessBenefitsReduceCarbonFootprint') }}</li>
          </ul>
        </div>
      </div>
    </div>
    <div modal-footer>
      <div class="w-full flex flex-wrap items-center justify-center gap-3">
        <button
          id="paperless-prompt-remind-btn"
          type="button"
          class="btn-outline-ld-purple"
          [disabled]="isLoading() || loadingAction()"
          (click)="onRemindLater()"
        >
          @if (loadingAction() === 'remind_later') {
            <mat-spinner diameter="16" class="w-4! h-4! [&_circle]:stroke-ld-primary!"></mat-spinner>
          }
          {{ t('goPaperlessButtonsRemindLater') }}
        </button>

        <button
          id="paperless-prompt-no-thanks-btn"
          type="button"
          class="btn-outline-ld-purple"
          [disabled]="isLoading() || loadingAction()"
          (click)="onNoThanks()"
        >
          @if (loadingAction() === 'no_thanks') {
            <mat-spinner diameter="16" class="w-4! h-4! [&_circle]:stroke-ld-neutral-500!"></mat-spinner>
          }
          {{ t('goPaperlessButtonsNoThanks') }}
        </button>

        <button
          id="paperless-prompt-go-btn"
          type="button"
          class="btn-primary-ld-purple"
          [disabled]="isLoading() || loadingAction()"
          (click)="onGoPaperless()"
        >
          @if (loadingAction() === 'go_paperless') {
            <mat-spinner diameter="20" class="w-5! h-5! [&_circle]:stroke-white!"></mat-spinner>
          }
          <span>{{ t('goPaperlessTitle') }}</span>
          @if (loadingAction() !== 'go_paperless') {
            <mat-icon class="w-5! h-5! text-[20px]!">arrow_forward</mat-icon>
          }
        </button>
      </div>
    </div>
  </ld-base-modal>
</ng-container>
